import RecipeList from "../components/Recipe/RecipeList";
import LoginButton from "../components/LoginButton";
import { useAuth } from "../gui/Login/AuthProvider";

export default function Recipes(){
    const {isLoggedIn} = useAuth()
    return <div id="recipes">
        {isLoggedIn ? <RecipeList/> : <LoginButton/>}
    </div>
}